import { createContext, useMemo, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import { State, Reducer } from './State';
import ActionFactory from './Actions';
import { Props } from '../../../models/Props.types';
import { MethodsData, MethodsFactory } from './MethodsContext.types';

const Methods = createContext<MethodsData>(State);
const MethodsDispatch = createContext<MethodsFactory>({} as MethodsFactory);

export function MethodsDataProvider(props: Props) {
    const { children } = props;
    const [value, dispatch] = useImmerReducer(Reducer, State);
    const actions = useMemo(() => ActionFactory(dispatch), [dispatch]);

    return (
        <Methods.Provider value={value}>
            <MethodsDispatch.Provider value={actions}>
                {children}
            </MethodsDispatch.Provider>
        </Methods.Provider>
    );
}

export function useMethods(): [MethodsData, MethodsFactory] {
    const state = useContext(Methods);
    const actions = useContext(MethodsDispatch);

    return [state, actions];
}
